import { useState, useEffect } from '@wordpress/element'
import { __ } from '@wordpress/i18n';
import { useDispatch, useSelect } from '@wordpress/data';

export const Servicepoints = (props) => {
    const VALIDATION_ERROR_PARCELSHOP_EMPTY = 'validation-error-parcelshop-empty'
    const getValidationError = useSelect((select) => {
        const store = select('wc/store/validation');

        return store.getValidationError( VALIDATION_ERROR_PARCELSHOP_EMPTY );
    });
    const [parcelshop, setParcelshop] = useState({})

    // Only run this once, intentionally no dependencies given
    useEffect(() => {
        const script = document.createElement('script')
        script.src = 'https://static.dhlparcel.nl/components/servicepoint-locator-component@latest/servicepoint-locator-component.js'
        script.async = true
        script.onload = () => loadModal()

        document.body.appendChild(script)
    }, [])

    const loadModal = () => {
        var options = {
            language: window.dhlpwc_block_data['language'],
            country: window.dhlpwc_block_data['country_code'] ?? '',
            limit: window.dhlpwc_block_data['limit'],
            googleMapsApiKey: window.dhlpwc_block_data['google_maps_key'],
            header: false,
            resizable: true,
            onSelect: (parcelshop) => {
                setParcelshop(parcelshop)
            },
            filter: {
                serviceType: 'pick-up'
            }
        }

        window.dhlparcel_shipping_servicepoint_locator = new dhl.servicepoint.Locator(document.getElementById('dhl-servicepoint-locator-component'), options)

        // Hide the parcelshop element when parcelshop is not selected
        const parcelshopDetails = document.getElementById('dhlpwc-shipping-method-parcelshop-option')
        if (props.selectedShippingMethod === 'dhlpwc-parcelshop') {
            parcelshopDetails.style.display = 'block'
        } else {
            parcelshopDetails.style.display = 'none'
        }

        // Hide the modal when clicking the X button
        document.getElementById('dhlpwc-modal-close').onclick = () => {
            document.getElementById('dhlpwc-servicepoint-modal').style.display = 'none'
        }

        // Set background image dynamically
        document.getElementById('dhlpwc-modal-content').style['background-image'] = 'url(' + window.dhlpwc_block_data['modal_background'] + ')'
    }

    /**
     * Set the initial parcelshop based on postalCode or countryCode
     */
    useEffect(() => {
        const parcelshopDetails = document.getElementById('dhlpwc-shipping-method-parcelshop-option')
        if (props.selectedShippingMethod === 'dhlpwc-parcelshop') {
            parcelshopDetails.style.display = 'block'

            // Wordpress doesn't like it when we post raw data, so we post it as a form instead
            const formData = new FormData();
            formData.append('action', 'dhlpwc_get_initial_parcelshop')
            formData.append('postal_code', props.postalCode)
            formData.append('country_code', props.countryCode)
            fetch(
                window.dhlpwc_block_data['ajax_url'],
                {
                    method: 'POST',
                    body: formData
                }
            ).then(async response => {
                response = await response.json()

                if (response.data?.parcelshop) {
                    setParcelshop(response.data.parcelshop)
                } else {
                    setParcelshop({})
                }
            })
        } else {
            parcelshopDetails.style.display = 'none'
            setParcelshop({})
        }
    }, [props.postalCode, props.selectedShippingMethod])

    const { setValidationErrors, clearValidationError } = useDispatch(
        'wc/store/validation'
    );

    /**
     * Sync the parcelshop (or lack of) with frontend elements and the backend
     *
     * @param parcelshop
     */
    useEffect( () => {
        document.getElementById('dhlpwc-servicepoint-modal').style.display = 'none'

        // Wordpress doesn't like it when we post raw data, so we post it as a form instead
        const formData = new FormData();
        formData.append('action', 'dhlpwc_parcelshop_selection_sync')
        if (Object.keys(parcelshop).length !== 0 || props.selectedShippingMethod !== 'dhlpwc-parcelshop') {
            props.setValidationClass('dhlpwc_notice')
            formData.append('parcelshop_id', parcelshop['id'] ?? '')
            formData.append('country_code', props.countryCode)
            if ( getValidationError ) {
                clearValidationError( VALIDATION_ERROR_PARCELSHOP_EMPTY );
            }
        } else {
            props.setValidationClass('dhlpwc-servicepoint-error')
            setValidationErrors( {
                [ VALIDATION_ERROR_PARCELSHOP_EMPTY ]: {
                    message: __( 'Please add some text', 'shipping-workshop' ),
                    hidden: true,
                },
            } );
        }

        fetch(
            window.dhlpwc_block_data['ajax_url'],
            {
                method: 'POST',
                body: formData
            }
        )
    }, [parcelshop]);

    /**
     * Show the parcelshop selector
     */
    const showModal = () => {
        if (props.postalCode === '') {
            document.getElementById('shipping-postcode').value
        }

        const modal = document.getElementById('dhlpwc-servicepoint-modal')
        modal.style.display = 'block'

        if (typeof window.dhlparcel_shipping_servicepoint_locator !== 'undefined') {
            window.dhlparcel_shipping_servicepoint_locator.setCountry(props.countryCode)
            window.dhlparcel_shipping_servicepoint_locator.setQuery(props.postalCode)
        }
    }

    return <div id='dhlpwc-shipping-method-parcelshop-option' className='dhlpwc-shipping-method-parcelshop-option'>
        <span className="dhlpwc-parcelshop-selection-text">{__('The following ServicePoint is selected:')}</span>
        <span className={`dhlpwc-parcelshop-option-message ${props.validationClass}`}>{parcelshop.name ?? __('⚠ No location selected.')}</span>
        <span className={`dhlpwc-parcelshop-option-message ${props.validationClass}`}>{parcelshop?.address?.postal_code} {parcelshop?.address?.city}</span>
        <span className={`dhlpwc-parcelshop-option-message ${props.validationClass}`}>{parcelshop?.address?.street} {parcelshop?.address?.number} {parcelshop?.address?.addition}</span>

        <input type='button' className='dhlpwc-parcelshop-option-change' value='Change' onClick={() => showModal()}/>
    </div>
};
